import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';

const RightPanel = ({ isVisible = false, onClose }) => {
  const navigate = useNavigate();

  const handleNavigate = (path) => (e) => {
    e.stopPropagation();
    navigate(path);
  };

  const handlePanelClick = () => {
    if (onClose) onClose();
  };

  return (
    <div
      data-testid="right-panel"
      onClick={handlePanelClick}
      className={`fixed top-24 right-6 z-40 transition-all duration-500 cursor-pointer ${
        isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-full pointer-events-none'
      }`}
    >
      <div className="bg-gradient-to-br from-orange-400 via-orange-500 to-red-500 rounded-3xl p-6 shadow-2xl w-80">
        <h3 className="text-2xl font-bold text-white mb-6 text-center">生命三大模擬系統</h3>
        <div className="space-y-3">
          <Button
            data-testid="panel-wealth-flow-btn"
            className="w-full rounded-full py-5 text-lg font-bold bg-white text-orange-500 hover:bg-orange-50 border-4 border-white transition-all duration-300 hover:scale-105"
            onClick={handleNavigate('/wealth-flow')}
          >
            財富流
          </Button>
          <Button
            data-testid="panel-rising-stars-btn"
            className="w-full rounded-full py-5 text-lg font-bold bg-white text-orange-500 hover:bg-orange-50 border-4 border-white transition-all duration-300 hover:scale-105"
            onClick={handleNavigate('/rising-stars')}
          >
            明日之星
          </Button>
          <Button
            data-testid="panel-spacetime-flow-btn"
            className="w-full rounded-full py-5 text-lg font-bold bg-white text-orange-500 hover:bg-orange-50 border-4 border-white transition-all duration-300 hover:scale-105"
            onClick={handleNavigate('/spacetime-flow')}
          >
            時空流
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RightPanel;
